// extracted by mini-css-extract-plugin
export var modalFooter = "_mr-0";